import { connect } from 'react-redux';
import Snackbar from './Snackbar';
import SnackbarVariant from './component/SnackbarVariant';
import { closeSnackbar, openSnackbar } from './redux';
import {
    VARIANT_SUCCESS,
    VARIANT_WARNING,
    VARIANT_ERROR,
    VARIANT_INFO,
    VARIANT_DISABLED,
} from './constants';

export default connect(
    (state) => {
        const { snackbar } = state;

        return { ...snackbar };
    },
    dispatch => ({
        onClose: () => dispatch(closeSnackbar()),
    }),
)(Snackbar);

export {
    SnackbarVariant,

    closeSnackbar,
    openSnackbar,

    VARIANT_SUCCESS,
    VARIANT_WARNING,
    VARIANT_ERROR,
    VARIANT_INFO,
    VARIANT_DISABLED,
};
